import { useState } from "react";
import { faqItems } from "@/mocks/articles";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              常见<span className="text-primary-500">问题</span>
            </h2>
            <p className="text-foreground-500 text-sm">
              关于911吃瓜网，你可能想了解这些
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="border border-background-200/70 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(idx)}
                  className="w-full flex items-center justify-between p-4 text-left hover:bg-background-100/50 transition-colors cursor-pointer"
                >
                  <h3 className="text-sm font-medium text-foreground-950 pr-4">
                    {item.question}
                  </h3>
                  <i
                    className={`flex-shrink-0 text-foreground-400 transition-transform duration-200 ${
                      openIndex === idx
                        ? "ri-subtract-line"
                        : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {openIndex === idx && (
                  <div className="px-4 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}